<template>
    <b-modal id="customer-choose-pharmaceutical" class="customer-show-quotation" ref="modal" :title="dialog_title"
        hide-footer>
        <div class="row form-group">
            <div class="col">
                <v-select style="flex-grow: 1;" ref="psearch" class="wabident-selector" @search="searchPharmaceuticals"
                    :filterable="false" :options="pharmaceuticals"
                    placeholder="Escribe el nombre del farmaco que quieres añadir"
                    v-model="selected_pharmaceutical"></v-select>
            </div>
            <div class="col-md-2">
                <button :disabled="!selected_pharmaceutical" class="btn btn-wabident-round btn-block mt-1"
                    @click="addPharmaceutical">
                    Añadir
                </button>
            </div>
        </div>
    </b-modal>
</div></template>

<script>
export default {
    data() {
        return {
            selected_pharmaceutical: null,
            searched_pharmaceuticals: [],
        }
    },
    computed: {
        pharmaceuticals() {
            return this.searched_pharmaceuticals.map((p) => {
                return {
                    label: p.title,
                    value: p
                };
            });
        },
        dialog_title() {
            return 'Añadir Fármaco';
        },
        ...mapGetters(['clinic'])
    },
    watch: {
        selected_pharmaceutical(val) {
        },
    },
    methods: {
        addPharmaceutical() {
            this.$emit('add', this.selected_pharmaceutical.value);
            this.$refs.modal.hide();
        },
        show() {
            this.selected_pharmaceutical = null;
            this.searched_pharmaceuticals = [];
            this.$refs.modal.show();
        },
        searchPharmaceuticals(search, loading = null) {
            if (loading) {
                loading(true);
            }

            const per_page = 20;
            const params = {
                search: search,
                per_page: per_page
            };

            axios
                .get(`/clinic/${this.clinic.id}/pharmaceuticals`, { params })
                .then((response) => {
                    this.searched_pharmaceuticals = response.data.data || [];
                })
                .catch((err) => {
                    console.log("[ERR] searchPharmaceuticals", err);
                    this.msgwindow.error("Error buscando fármacos");
                })
                .then(() => {
                    loading(false);
                });
        },
    }
}
</script>

<style lang="scss">
#customer-choose-pharmaceutical {

    .modal-dialog {
        border-radius: 0;
        max-width: 1024px;
    }

    .modal-header {
        background-color: var(--theme-grey-bg);
    }

    .modal-header,
    .modal-content {
        border-radius: 0;
    }

    .modal-title {
        margin: 0;
        text-align: left;
        font-size: 18px;
    }

    .close {
        top: 15px;
    }

    .modal-body {
        padding: 20px;
    }
}
</style>